import { TextField, InputAdornment } from '@mui/material';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';

export const SearchBar = ({ onChange, onKeyDown, ...other }) => (
  <TextField
    onChange={onChange}
    onKeyDown={onKeyDown}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Iconify
            sx={{
              color: theme => theme.palette.content.primaryBlack3,
            }}
            icon="tabler:search"
          />
        </InputAdornment>
      ),
    }}
    placeholder="Search"
    {...other}
  />
);

SearchBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
};
